import { actionImplies } from "./actionImplications";

/**
 * When `scopes` is given, only grants with one of those scopes count. Grants without scope
 * information are treated as ANY, the same way the backend treats rows without a scope.
 */
export function canFromGrants({ ready, grants, resource, action = "view", scopes = null }) {
  if (!ready || !resource) return false;

  const scopeAllowed = (grantedResource, grantedAction) => {
    if (!Array.isArray(scopes)) return true;
    const grantedScopes = grants?.__scopes?.[grantedResource]?.[grantedAction];
    if (!Array.isArray(grantedScopes) || grantedScopes.length === 0) return scopes.includes("ANY");
    return grantedScopes.some((scope) => scopes.includes(scope));
  };

  const grantsFor = (grantedResource) => Object.fromEntries(
    Object.entries(grants?.[grantedResource] || {})
      .filter(([grantedAction, granted]) => granted && scopeAllowed(grantedResource, grantedAction))
  );

  const res = { ...grantsFor("*"), ...grantsFor(resource) };

  if (res.__all) return true;
  if (grants?.__effective) {
    return Boolean(res[action] || res["*"]);
  }

  return Object.keys(res).some(
    (grantedAction) => res[grantedAction] && actionImplies(grantedAction, action)
  );
}
